import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { toast } from 'sonner';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post('/auth/login', { email, password });
      localStorage.setItem('mb_token', r.data.access_token);
      localStorage.setItem('mb_email', r.data.email);
      toast.success('Welcome back');
      navigate('/admin');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[color:var(--mb-bg)]" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex flex-col items-center gap-3 mb-10">
          <img src="/brand/mark.jpg" alt="" className="h-16 w-auto" style={{ mixBlendMode: 'multiply' }} />
          <div className="text-center">
            <div className="font-serif-display text-2xl text-[color:var(--mb-primary)] lowercase" style={{ fontWeight: 500 }}>mahabir Bastralaya</div>
            <div className="text-[0.6rem] tracking-[0.4em] text-[color:var(--mb-text-muted)] mt-1">ADMIN</div>
          </div>
        </Link>
        <div className="border border-[color:var(--mb-border)] p-8 sm:p-10 bg-[color:var(--mb-surface)]">
          <h1 className="font-serif-display text-3xl mb-8">Admin Sign in</h1>
          <form onSubmit={submit} className="flex flex-col gap-5">
            <div>
              <label className="eyebrow block mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                className="w-full px-4 py-3 bg-[color:var(--mb-bg)] border border-[color:var(--mb-border)] text-sm focus:border-[color:var(--mb-primary)] outline-none"
                style={{ transition: 'border-color 200ms ease' }}
              />
            </div>
            <div>
              <label className="eyebrow block mb-2">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="w-full px-4 py-3 bg-[color:var(--mb-bg)] border border-[color:var(--mb-border)] text-sm focus:border-[color:var(--mb-primary)] outline-none"
                style={{ transition: 'border-color 200ms ease' }}
              />
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-red justify-center mt-2">
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
